export default __webpack_public_path__ + "static/media/VS.c073a6fd.svg";